var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c(_setup.Navbar,{attrs:{"transparent":_vm.$route.path ==='/home'}}),_c('router-view'),_c('portal-target',{attrs:{"name":"body"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"alert"},[_c('span',[_vm._v("Beta worlds are on the Devnet network - you will need some initial Devnet SOL to play!")])])
}]

export { render, staticRenderFns }